import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PricingCalculatorComponent } from './pricing-calculator.component';

const routes: Routes = [
  {
    path: '',
    component: PricingCalculatorComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PricingCalculatorRoutingModule { }